/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Download_SubtitleInputs */

const en_home_download_subtitle = /** @type {(inputs: Home_Download_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows users get a 64-bit MSI installer, Mac users a universal DMG for Apple silicon and Intel, and Linux users a Flatpak with AppImage, .deb and .rpm alternatives. Every official release ships SHA-256 checksums so you can verify the file.`)
};

/**
* | output |
* | --- |
* | "Windows users get a 64-bit MSI installer, Mac users a universal DMG for Apple silicon and Intel, and Linux users a Flatpak with AppImage, .deb and .rpm alter..." |
*
* @param {Home_Download_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_download_subtitle = /** @type {((inputs?: Home_Download_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Download_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_download_subtitle(inputs)
});
export { home_download_subtitle as "home.download.subtitle" }